import React from "react";
import { motion } from "framer-motion";

const achievements = [
  "Delivered innovative websites, mobile apps, and scalable digital platforms across multiple industries",
  "Built strong reputation for combining creativity with solid technical expertise",
  "Focused on seamless user experience and modern, clean design standards",
  "Achieved high client satisfaction through timely delivery and reliable support",
  "Continuously transforming ideas into impactful, growth-driven digital products",
];

const InnovationAchievements = () => {
  return (
    <section className="bg-[#ffffff] overflow-hidden lg:pb-[88px] pb-[40px]">
      <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

        <div className="flex flex-col lg:flex-row items-start justify-between lg:gap-[70px] gap-[24px] md:gap-[40px]">

          <motion.div
            initial={{ opacity: 0, y: -10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            variants={{
              lg: { initial: { opacity: 0, x: -60, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
            }}
            className="max-w-full lg:max-w-[257px] w-full"
          >
            <h2 className="text-[#01386A] font-[600] font-sora leading-tight lg:leading-[1.2] text-[20px] lg:text-[30px]">
              Our Innovation Labs
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="overflow-hidden w-full lg:w-[390px] h-[200px] sm:h-[250px] lg:h-[230px] shrink-0 rounded-sm"
          >
            <img
              src="/assets/lab/img4.png"
              alt="Innovation Labs"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            variants={{
              lg: { initial: { opacity: 0, x: 60, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
            }}
            className="max-w-full lg:max-w-[356px] w-full"
          >
            <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik font-[500] leading-[22px] md:leading-[24px]">
              Makers Lab is our space for curiosity and creation, where ideas are explored without limits. It’s where we experiment with technology, design, and problem-solving to build real solutions. Together, our team learns, tests, and creates innovative products that turn imagination into practical impact for businesses and people in everyday life.
            </p>
          </motion.div>
        </div>

        <div className="mt-[40px] sm:mt-[60px] lg:mt-[100px] flex flex-col lg:flex-row items-start justify-between lg:gap-[70px] gap-[24px] md:gap-[40px]">

          <motion.div
            initial={{ opacity: 0, y: -10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            variants={{
              lg: { initial: { opacity: 0, x: -60, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
            }}
            className="max-w-full lg:max-w-[295px] w-full"
          >
            <h2 className="text-[#01386A] font-[600] font-sora leading-tight lg:leading-[1.2] text-[20px] lg:text-[30px]">
              Our Achievements
            </h2>
          </motion.div>

          <div className="flex flex-col gap-[16px] sm:gap-[24px] max-w-full lg:max-w-[760px] w-full">

            {achievements.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  delay: index * 0.12,
                  duration: 0.6,
                }}
                viewport={{ once: true }}
                whileHover={window.innerWidth >= 1024 ? { x: 10 } : {}}
                className="group flex items-start gap-[12px] cursor-pointer"
              >
                <div className="shrink-0 pt-[4px]">
                  <img src="/assets/lab/wrap1.svg" alt="" className="w-[14px] h-[14px] sm:w-auto sm:h-auto" />
                </div>

                <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik font-[500] leading-[20px] sm:leading-[24px] transition-all duration-300 group-hover:text-[#01386A]">
                  {item}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnovationAchievements;